import React from "react";

import { Props } from "./types";

function EditIcon({ className }: Props) {
  return (
    <svg className={className} viewBox="0 0 14 14">
      <path
        d="M11.35 1.263a1.312 1.312 0 0 0-1.857 0l-1.05 1.05-.002.003-.002.001-7.436 7.436a.437.437 0 0 0-.128.31v2.624c0 .242.196.438.438.438h2.625a.437.437 0 0 0 .309-.128l7.436-7.436.001-.002.002-.001 1.05-1.051a1.312 1.312 0 0 0 0-1.856L11.35 1.263zm-9.6 8.98 7-7 2.006 2.007-7 7H1.75v-2.006zm7.619-7.618 2.006 2.006.743-.743a.438.438 0 0 0 0-.619l-1.387-1.387a.437.437 0 0 0-.62 0l-.742.743z"
        fillRule="evenodd"
        clipRule="evenodd"
      />
    </svg>
  );
}

export { EditIcon };
